import React from 'react';
import ParentContainerSelector from '../../components/ccp/ParentContainerSelector';

const Connect = () => {
  return (
      <div
        data-testid="connect-container"
        className="ccp-route flex flex-row mx-4"
      >
        {/* Mimics user agent stylesheet for Connect work. Tailwind normalizes CSS by default. */}
        <style>
          {`
            p {
              display: block;
              margin-block-start: 1em;
              margin-block-end: 1em;
              margin-inline-start: 0px;
              margin-inline-end: 0px;
            }
            hr {
              display: block;
              margin-block-start: 0.5em;
              margin-block-end: 0.5em;
              margin-inline-start: auto;
              margin-inline-end: auto;
              overflow: hidden;
            }
       `}
        </style>
        <ParentContainerSelector />
      </div>
  );
};
export default Connect;
